import { render, staticRenderFns } from "./Bme.vue?vue&type=template&id=4a1c3630"
import script from "./Bme.vue?vue&type=script&lang=js"
export * from "./Bme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports